import { Container, Heading, Box, Flex } from '@chakra-ui/layout';
import React, { useEffect } from 'react';
import { useColorMode, Link, Image, Tooltip, Grid } from '@chakra-ui/react';
import { motion, useViewportScroll } from 'framer-motion';
import Reveal from './../components/Reveal';
import { ProjectsSvg } from '../components/projectsSVG';
import ProjectsContent from '../components/ProjectsContent';

const MotionContainer = motion(Container);

const Projects = ({ focused }) => {
  const { colorMode } = useColorMode();

  return (
    <MotionContainer
      maxW={{
        base: 'container.sm',
        md: 'container.md',
        lg: 'container.lg',
        xl: 'container.xl',
      }}
      transition="linear .1s"
      pb={8}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      exit={{ opacity: 0 }}
      overflow="hidden"
    >
      <motion.div
        className="projects-svg"
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '30px',
          marginBottom: '20px',
          position: 'relative',
        }}
      >
        <ProjectsSvg />
      </motion.div>
      <Box
        className="projects-content"
        pt={6}
        pb={6}
        position="relative"
        transition="linear 0.1s"
        borderRadius="2xl"
        border="4px"
        borderColor={focused ? 'blue.200' : 'transparent'}
        backgroundColor={colorMode === 'light' ? 'white' : '#1A202C'}
      >
        <Reveal>
          <Box textAlign="center" mt={12} mb={12}>
            <Heading as="h1" size="2xl">
              My Projects
            </Heading>
          </Box>
        </Reveal>
        <Reveal>
          <Heading as="p" size="md" lineHeight={1.4} mr={6} ml={6}>
            Here are my projects, sorted by the complexity of the project.
          </Heading>
        </Reveal>
        <ProjectsContent />
      </Box>
    </MotionContainer>
  );
};

export default Projects;
